<template>
  <div>
    <div class="row">
      <div class="col-12 mb-3">
        <h3 class="text-h5 text-center text-weight-bolder text-grey-14">These are some useful links</h3>
      </div>
      <div class="col-4 offset-4">
        <q-select class="searchBox my-2" :options="OEMs" label="OEM" map-options option-label="name" option-value="id" outlined
                   use-input v-model="selectedOEM"></q-select>
      </div>
    </div>
    <q-page-container class="px-3 pt-5">
      <div v-for="category in Object.keys(usefulLinks)" class="mb-5">
        <div class="row" v-if="usefulLinks[category]&&usefulLinks[category].length">
          <div class="col-12 pl-3 d-flex justify-content-between">
            <div class="d-flex" >
              <div style="width: 5px; background: #0e88ce"></div>
              <h5 class="text-h5 ml-2 mt-1" style="font-family: 'Avenir Bold'"> {{ category }}</h5>
            </div>
            <span class="" style="font-size: 22px">{{usefulLinks[category].length}}</span>
          </div>
          <div class="col-12 pl-3 mt-2">
            <div style="border-top: 1px solid lightgrey"></div>
          </div>
          <div class="col-3 q-pa-md" v-for="link in usefulLinks[category]">
            <div @click="openInNewTab(link.redirectUrl)" class="linkBox">
              <img :src="link.imageUrl" class="d-block mx-auto "/>
            </div>
          </div>
        </div>
      </div>
    </q-page-container>
    <!--    <div class="row">-->
    <!--      <div class="col-8 q-pa-md ">-->
    <!--        <div class="row">-->
    <!--          <div class="col-4 q-pa-md" v-for="link in linksArr">-->
    <!--            <div @click="openInNewTab(link.urlPath)" class="linkBox ">-->
    <!--              <img :src="link.iconPath" class="d-block mx-auto " style="width: 90%;"/>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="col-4 q-pa-md ">-->
    <!--        <div class="robot">-->
    <!--          <img alt="" class=" d-block mx-auto mt-5" src="../assets/eset_robot.png" style="width: 70%; ">-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {SUBSCRIBE_USEFUL_LINKS} from "@/graphql/subscription/UsefulLinks";
import {GET_ALL_OEM} from "@/graphql/queries/products";

const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    return result;
  }, {});
};
export default {
  name: 'Links',
  apollo: {
    OEMs: {
      query: GET_ALL_OEM,
      fetchPolicy: 'network-only',
      result({data, loading}) {
        if (!loading) {
          this.OEMs = JSON.parse(JSON.stringify(data.OEMs))
          this.allOEMIds = data.OEMs.map(oem => oem.id)
          this.OEMs.unshift(this.selectedOEM)
        }
      }
    },
    $subscribe: {
      UsefulLink: {
        query: SUBSCRIBE_USEFUL_LINKS,
        fetchPolicy: 'network-only',
        variables() {
          return {
            partnerType: this.loggedIn_partnerType,
            oemId: this.selectedOEM.id ? this.selectedOEM.id : this.allOEMIds.filter(Boolean)
          }
        },
        result({data, loading}) {
          if (!loading) {
            let temp = groupBy(data.UsefulLink, 'categoryId')
            this.usefulLinks['Sales'] = temp['68bacab5-7a65-4522-a68e-fcfa4586d67d']
            this.usefulLinks['Marketing'] = temp['198402e4-d530-4a10-8a3b-ebb1a84c3d98']
            this.usefulLinks['Technical'] = temp['32d906f9-d7d1-4d92-aaa5-a950ba5aca0b']
          }
        }
      },
    }
  },
  data() {
    return {
      loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
      OEMs: [],
      selectedOEM: {name: 'All', id: null},
      allOEMIds: [],
      usefulLinks: {'Sales': [], 'Marketing': [], 'Technical': [],},
      linksArr: [
        {
          urlPath: 'https://www.eset.com/in/', name: 'ESET WEBSITE', caption: 'Enjoy Safer Technology',
          iconPath: require('../assets/images/ESET INDIA WEBSITE.png'),
        },
        {
          urlPath: 'https://my.eset.com/', name: 'MY ESET WEBSITE', caption: 'Enjoy Knowledgebase',
          iconPath: require('../assets/MYESET.png'),
        },
        {
          urlPath: 'https://support.eset.com/', name: 'ESET Knowledge Base', caption: 'Enjoy Knowledgebase',
          iconPath: require('../assets/images/ESET KNOWLEDGEBASE.png'),
        },
        {
          urlPath: 'https://www.welivesecurity.com/', name: 'WE LIVE SECURITY', caption: '',
          iconPath: require('../assets/images/WELIVESECURITY.png'),
        },
        {
          urlPath: 'https://www.virusradar.com', name: 'VIRUS RADAR', caption: '',
          iconPath: require('../assets/images/ESET VIRUS RADAR.png'),
        },
        {
          urlPath: 'https://saferkidsonline.eset.com', name: 'ESET Saferkidsonline', caption: '',
          iconPath: require('../assets/images/SAFERKIDSONLINE.png'),
        },
        // {
        //   urlPath: 'https://kb.eset.com/', name: 'ESET SUPPORT', caption: 'Enjoy Safer Technology',
        //   iconPath:require('../assets/images/ESET SUPPORT.png'),
        // },
        {
          urlPath: 'https://www.eset.com/in/about/contact/',
          name: '.ESET Helpdesk Contact',
          caption: 'Enjoy Safer Technology',
          iconPath: require('../assets/ESET SUPPORT.png'),
        },
        {
          urlPath: 'https://www.eset.com/blog/', name: '.ESET Helpdesk Contact', caption: 'ESET Blog',
          iconPath: require('../assets/images/ESET BLOG.png'),
        },
        // {
        //   urlPath: 'https://www.eset.com/us/business/resources/datasheets-list/',
        //   name: 'SALES DATASHEET',
        //   caption: 'Enjoy Safer Technology',
        //   iconPath: require('../assets/images/SAFERKIDSONLINE.png'),
        // },
      ],
    }
  },
  methods: {
    openInNewTab: function (url) {
      var win = window.open(url, '_blank')
      win.focus()
    },
  },
}
</script>

<style scoped>

</style>
